import { z } from "zod"

export const renameFlashcardSchema = z.object({
  name: z.string().trim().min(1, "El nombre es obligatorio.").max(50, "Máximo 50 caracteres."),
})

export type RenameFlashcardSchemaType = z.infer<typeof renameFlashcardSchema>
